import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';

class Footer extends Component {
	render() {
		return (
			<footer /*className="footer"*/>
				<Grid fluid>
					<p className="copyright pull-left" style={{ color: 'white' }}>
						&copy; {new Date().getFullYear()} <a href="https://www.macizo.com.gt">Macizo WVR </a>
						
					</p>
				</Grid>
			</footer>
		);
	}
}

export default Footer;
